import React from "react";
import { TagsProps } from "./Tags.types";
import { TagLabel, StyledIcon } from "./Tags.styles";
import FlexRow from "../Layout/FlexRow/FlexRow";
import FlexColumn from "../Layout/FlexColumn/FlexColumn";

export const Tags: React.FC<TagsProps> = ({
  variant = "primary",
  label,
  onClick,
  onIconClick,
  onCrossClick,
  icon,
  iconColor,
  color,
  backgroundColor,
  dataCy,
  className,
  showCross = false,
  crossColor,
  uppercase = false,
  border = "",
}) => {
  const defaultBackgroundColor =
    variant === "primary"
      ? "background.wishlink.default"
      : "background.wishlink.tertiary";

  const defaultTextColor =
    variant === "primary"
      ? "text.wishlink.on-wishlink"
      : "text.wishlink.on-wishlink-tertiary";

  const finalBackgroundColor = backgroundColor || defaultBackgroundColor;
  const finalColor = color || defaultTextColor;
  const finalIconColor = iconColor || defaultTextColor;
  const finalCrossColor = crossColor || defaultTextColor;
  const handleContainerClick = (
    event: React.MouseEvent<HTMLSpanElement, MouseEvent>
  ) => {
    event.stopPropagation();
    if (onClick) {
      onClick(event);
    }
  };

  const handleIconClick = (
    event: React.MouseEvent<HTMLSpanElement, MouseEvent>
  ) => {
    event.stopPropagation();
    if (onIconClick) {
      onIconClick(event);
    }
  };

  const handleCrossClick = (
    event: React.MouseEvent<HTMLSpanElement, MouseEvent>
  ) => {
    event.stopPropagation();
    if (onCrossClick) {
      onCrossClick(event);
    }
  };

  return (
    <FlexRow
      width="unset"
      p={6}
      alignItems="center"
      justifyContent="center"
      gap={4}
      borderRadius={4}
      backgroundColor={finalBackgroundColor}
      color={finalColor}
      onClick={handleContainerClick}
      className={className}
      data-cy={dataCy}
      border={border}
    >
      {icon && (
        <FlexColumn
          alignItems="center"
          justifyContent="center"
          onClick={handleIconClick}
          cursor="pointer"
          height="10px"
          width="10px"
        >
          <StyledIcon className={icon} iconColor={finalIconColor} />
        </FlexColumn>
      )}
      <TagLabel color={color} textTransform={uppercase ? "uppercase" : "none"}>
        {label}
      </TagLabel>
      {showCross && (
        <FlexColumn
          alignItems="center"
          justifyContent="center"
          onClick={handleCrossClick}
          cursor="pointer"
          height="10px"
          width="10px"
        >
          <StyledIcon
            className="fa-solid fa-xmark"
            iconColor={finalCrossColor}
          />
        </FlexColumn>
      )}
    </FlexRow>
  );
};

export default Tags;
